var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 257,
    viewBox: "0 0 187 257",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.3458 78.0574L91.0728 54.3304C86.8546 56.7408 82.9529 59.6181 79.4127 62.8872L75.9026 66.3973C72.6335 69.9224 69.7562 73.8392 67.3458 78.0574Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2654 96.9189L109.934 47.2505C108.563 47.5217 107.207 47.8531 105.866 48.2146L61.2295 92.8514C60.8529 94.1922 60.5365 95.548 60.2654 96.9189Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 109.543C59 109.679 59 109.814 59 109.95L122.95 46C122.814 46 122.679 46 122.543 46C121.624 46 120.705 46.0301 119.786 46.0602L59.0602 106.786C59.0301 107.705 59 108.609 59 109.543Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9942 120.736L133.766 46.9639C132.877 46.8133 131.973 46.6626 131.085 46.5421L59.5874 118.039C59.6929 118.958 59.8285 119.847 59.9942 120.736Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4046 130.106L143.121 49.3896C142.338 49.1184 141.555 48.8774 140.771 48.6364L61.6664 127.741C61.8924 128.54 62.1334 129.323 62.4046 130.106Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9146 138.377L151.407 52.8845C150.714 52.538 150.021 52.1915 149.313 51.8751L64.8903 136.283C65.2217 136.991 65.5531 137.684 65.9146 138.377Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3135 145.743L158.759 57.2985C158.141 56.8767 157.523 56.4548 156.906 56.0481L69.0783 143.875C69.4851 144.508 69.8917 145.126 70.3135 145.743Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.541 152.296L165.312 62.5257C164.769 62.0285 164.212 61.5465 163.655 61.0795L74.0797 150.654C74.5618 151.212 75.0439 151.754 75.541 152.296Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.5368 158.082L171.097 68.5219C170.63 67.9645 170.147 67.4071 169.65 66.8647L79.8797 156.635C80.422 157.133 80.9794 157.615 81.5368 158.082Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3159 163.083L176.113 75.2857C175.706 74.653 175.3 74.0353 174.863 73.4327L86.4479 161.848C87.0655 162.269 87.6832 162.691 88.3159 163.083Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9235 167.256L180.271 82.9083C179.94 82.2003 179.608 81.5073 179.262 80.8143L93.8296 166.246C94.5226 166.593 95.2155 166.924 95.9235 167.256Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.48 170.48L183.51 91.4655C183.269 90.6671 183.028 89.8837 182.772 89.1154L102.13 169.757C102.899 169.998 103.682 170.239 104.48 170.48Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.182 172.544L185.559 101.167C185.438 100.263 185.303 99.3745 185.152 98.4706L111.501 172.122C112.389 172.288 113.278 172.423 114.182 172.544Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.558 173.101C123.537 173.101 124.516 173.071 125.481 173.026L186.041 112.466C186.086 111.501 186.116 110.522 186.116 109.543C186.116 109.468 186.116 109.377 186.116 109.302L122.332 173.086C122.392 173.086 122.483 173.101 122.558 173.101Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.476 170.811L183.826 126.461C184.203 125.12 184.534 123.749 184.805 122.378L135.378 171.806C136.764 171.52 138.135 171.188 139.476 170.811Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.544 141.42L154.435 164.529C164.001 158.97 171.985 150.986 177.544 141.42Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.54919 206.096L11.1044 193.443C8.8549 194.728 6.77409 196.263 4.88609 198.006L3.01414 199.878C1.27076 201.758 -0.263746 203.847 -1.54919 206.096Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.3252 216.155L21.1631 189.667C20.432 189.812 19.7089 189.988 18.9939 190.181L-4.811 213.986C-5.01186 214.701 -5.18058 215.424 -5.3252 216.155Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6 222.888C-6 222.96 -6 223.032 -6 223.105L28.1045 189C28.0322 189 27.9599 189 27.8876 189C27.3975 189 26.9074 189.016 26.4174 189.032L-5.96788 221.417C-5.98395 221.907 -6 222.39 -6 222.888Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.46983 228.857L33.8729 189.514C33.3989 189.434 32.9169 189.353 32.4429 189.289L-5.68677 227.419C-5.63053 227.909 -5.55821 228.383 -5.46983 228.857Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.18434 233.854L38.8621 190.807C38.4443 190.663 38.0265 190.534 37.6088 190.406L-4.578 232.592C-4.45749 233.018 -4.32895 233.436 -4.18434 233.854Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.31239 238.264L43.2808 192.671C42.9113 192.486 42.5417 192.302 42.1641 192.133L-2.8587 237.148C-2.68195 237.525 -2.5052 237.895 -2.31239 238.264Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0335659 242.193L47.2015 195.026C46.8721 194.801 46.5427 194.576 46.2133 194.359L-0.625183 241.197C-0.408263 241.535 -0.191387 241.864 0.0335659 242.193Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82132 245.688L50.6962 197.813C50.407 197.548 50.1097 197.291 49.8125 197.042L2.04199 244.813C2.29908 245.11 2.5562 245.399 2.82132 245.688Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.01885 248.773L53.7813 201.011C53.5322 200.714 53.2751 200.416 53.01 200.127L5.13513 248.002C5.42435 248.267 5.72159 248.524 6.01885 248.773Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.63422 251.441L56.4567 204.618C56.2397 204.281 56.0228 203.951 55.7898 203.63L8.638 250.782C8.9674 251.007 9.29679 251.232 9.63422 251.441Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6914 253.666L58.6741 208.683C58.4974 208.306 58.3206 207.936 58.1358 207.567L12.5747 253.128C12.9443 253.313 13.3138 253.489 13.6914 253.666Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2548 255.385L60.4014 213.247C60.2729 212.821 60.1443 212.403 60.0077 211.994L17.0015 255C17.4112 255.128 17.829 255.257 18.2548 255.385Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4287 256.486L61.494 218.421C61.4297 217.939 61.3574 217.465 61.2771 216.983L21.9986 256.261C22.4727 256.35 22.9466 256.422 23.4287 256.486Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8956 256.783C28.4178 256.783 28.94 256.767 29.4542 256.743L61.751 224.446C61.7752 223.932 61.7912 223.41 61.7912 222.887C61.7912 222.847 61.7912 222.799 61.7912 222.759L27.7751 256.775C27.8072 256.775 27.8554 256.783 27.8956 256.783Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9179 255.562L60.5701 231.91C60.771 231.195 60.9477 230.464 61.0923 229.733L34.7326 256.093C35.4717 255.94 36.2028 255.763 36.9179 255.562Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2199 239.888L44.8957 252.212C49.9973 249.247 54.2553 244.989 57.2199 239.888Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-29 33.8876C-29 33.9599 -29 34.0322 -29 34.1045L5.10449 0C5.03218 0 4.95991 0 4.8876 0C4.39753 0 3.90743 0.0160627 3.41736 0.0321308L-28.9679 32.4174C-28.9839 32.9074 -29 33.3895 -29 33.8876Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.4698 39.8567L10.8729 0.514016C10.3989 0.433675 9.91687 0.353335 9.44286 0.289062L-28.6867 38.4186C-28.6305 38.9087 -28.5582 39.3827 -28.4698 39.8567Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.1844 44.8538L15.8621 1.80734C15.4443 1.66273 15.0265 1.53418 14.6088 1.40564L-27.578 43.5924C-27.4575 44.0182 -27.329 44.436 -27.1844 44.8538Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-25.3124 49.2643L20.2808 3.67109C19.9113 3.48631 19.5417 3.30153 19.1641 3.13281L-25.8587 48.1476C-25.6819 48.5252 -25.5052 48.8947 -25.3124 49.2643Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.9664 53.1935L24.2015 6.02559C23.8721 5.80064 23.5427 5.57568 23.2133 5.35876L-23.6252 52.1973C-23.4083 52.5347 -23.1914 52.8641 -22.9664 53.1935Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.1786 56.6883L27.6962 8.81338C27.407 8.54825 27.1097 8.29117 26.8125 8.04211L-20.958 55.8125C-20.7009 56.1098 -20.4438 56.399 -20.1786 56.6883Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.9811 59.7733L30.7813 12.0109C30.5322 11.7137 30.2751 11.4164 30.01 11.1272L-17.8648 59.0021C-17.5756 59.2672 -17.2784 59.5243 -16.9811 59.7733Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.3658 62.4406L33.4567 15.6182C33.2397 15.2807 33.0228 14.9514 32.7898 14.63L-14.362 61.7818C-14.0326 62.0068 -13.7032 62.2317 -13.3658 62.4406Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.30856 64.6661L35.6741 19.6835C35.4974 19.3059 35.3206 18.9363 35.1358 18.5668L-10.4253 64.1278C-10.0557 64.3126 -9.68616 64.4894 -9.30856 64.6661Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4.74518 66.3854L37.4014 24.2469C37.2729 23.8211 37.1443 23.4033 37.0077 22.9935L-5.99854 65.9998C-5.5888 66.1283 -5.17098 66.2569 -4.74518 66.3854Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.428694 67.4864L38.494 29.4211C38.4297 28.9391 38.3574 28.4651 38.2771 27.983L-1.00134 67.2615C-0.527332 67.3498 -0.0533488 67.4222 0.428694 67.4864Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89562 67.783C5.41783 67.783 5.94 67.7669 6.45418 67.7428L38.751 35.4459C38.7752 34.9317 38.7912 34.4095 38.7912 33.8873C38.7912 33.8472 38.7912 33.799 38.7912 33.7588L4.77509 67.7749C4.80722 67.7749 4.85545 67.783 4.89562 67.783Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9179 66.5624L37.5701 42.9101C37.771 42.1951 37.9477 41.464 38.0923 40.7329L11.7326 67.0926C12.4717 66.94 13.2028 66.7632 13.9179 66.5624Z",
    fill: "#4643C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.2199 50.8876L21.8957 63.2118C26.9973 60.2473 31.2553 55.9892 34.2199 50.8876Z",
    fill: "#4643C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 257,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.2e15a60b3fc01e1285dd890b0d29890e.svg";
export { ForwardRef as ReactComponent };